import classNames from "classnames";

function NavButton({ text, selected, onClick }) {
  return (
    <div
      className={classNames("w-full h-max px-2 py-2 ps-nav-button", {
        "ps-nav-button-selected": selected,
        "ps-nav-button-unselected": !selected,
      })}
      onClick={onClick}
    >
      <span className="w-max">
        {text}
      </span>
    </div>
  );
}

export default NavButton;
